module.exports = __webpack_public_path__ + "static/media/uber_testimonial.ed5b2fd6.svg";